import { Form, Select } from 'antd'
import React from 'react'

const { Option } = Select

const Reruns = ({ defaultReRuns, setReRuns }) => {
  const handleChange = (value) => {
    setReRuns(value)
  }

  return (
    <Form.Item label="Re-runs">
      <Select
        defaultValue={defaultReRuns}
        onChange={handleChange}
        placeholder="Select"
      >
        <Option value="with">Including</Option>
        <Option value="without">Excluding</Option>
      </Select>
    </Form.Item>
  )
}

export default Reruns
